import {
  STM_DURATION_BASED_PRODUCT_NAMES,
  STM_DURATION_BASED_PRODUCTS
} from 'core/constants/products'

function isSTMPlan(plan) {
  return (
    plan &&
    (plan.productId
      ? STM_DURATION_BASED_PRODUCTS.includes(plan.productId)
      : STM_DURATION_BASED_PRODUCT_NAMES.includes(plan.planType))
  )
}

export default isSTMPlan
